import config, {layers} from "./config.kotka.atmospheric";

export {layers};

export default config;
